import { render, staticRenderFns } from "./cart-for-later.vue?vue&type=template&id=f5b5f4ba"
import script from "./cart-for-later.vue?vue&type=script&lang=js"
export * from "./cart-for-later.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports